<script>
export default {
  data() {
    return {
      dropUp: false,
    };
  },
  mounted() {
    // this.handleDropUp2();
  },
  methods: {
    handleDropUp() {
      const el = this.$refs["drop-up"];
      const domRect = el.getBoundingClientRect();
      let spaceBelow = window.innerHeight - domRect.bottom;
      window.onresize = () => {
        spaceBelow = window.innerHeight - domRect.bottom;
        this.dropUp = spaceBelow < 240;
      };
    },
  },
};
</script>
